import React, { Component } from 'react';

class ExampleGen extends Component {
    static getRandomSituation = () => {
        let LINKS = [
            '/?n=6&h=As,Ah&s=Ac,5h,5s',
            '/?n=6&h=Ad,Ah&s=Ac,5c,Jc',
            '/?n=6&h=Ks,Qc&s=Ac,5c,Jc',
            '/?n=6&h=Kc,Qc&s=Ac,5c,Jh',
            '/?n=6&h=Kc,Qc&s=Ac,5c,Jh,10d',
            '/?n=6&h=10c,Qc&s=Ac,5h,Jh',
            '/?n=6&h=10c,Qc&s=Ac,5h,Jc'
        ]

        let randomLinksIndex = Math.floor(Math.random() * LINKS.length);
        return LINKS[randomLinksIndex]
    }

    render() {
        return (
            <div className="mb-5 mt-5 text-center">
                <a href={ExampleGen.getRandomSituation()} className="switch">
                    Try an Example
                </a>
            </div>
        )
    }
}

export default ExampleGen;